// extracted by mini-css-extract-plugin
export var legendIndicator = "_e9-1";
export var legendRight = "_e9-0";